// Wording helpers
export function ucFirst(t) {
  return t.replace(/^./, (c) => c.toUpperCase());
}

export function ucFirstEachWord(t) {
  return t.replaceAll(/(^| +|\()\w/g, (c) => c.toUpperCase());
}

export function a_or_an(noun) {
  return (noun.match(/^[aeiou]/) ? "an " : "a ") + noun;
}
